import React from "react";
import { useHeaderContext } from "../context/HeaderContext";

const PersistentHeader = () => {
  const {
    user,
    searchTerm,
    setSearchTerm,
    isMemoryOpen,
    setIsMemoryOpen,
    groqLoading,
    error,
    setError,
    location,
    groqContext,
    fieldNotes,
  } = useHeaderContext();
  
  React.useEffect(() => {
    setIsMemoryOpen(false);
  }, [setIsMemoryOpen]);

  // Only render header when logged in (user can be null or undefined)
  // If you want to always show header, remove this check
  // if (!user) return null;

  let displayName = "Guest";
  if (user && user.email) {
    displayName = user.email.split("@")[0];
  }



  return (
    <header className="sticky top-0 w-full bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 shadow-2xl border-b border-slate-700/50 z-50 relative overflow-hidden pt-16">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-4 gap-2 relative">
        {/* Left: User info and location */}
        <div className="flex flex-col gap-2 min-w-[200px]">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2 bg-slate-800/50 rounded-full px-4 py-1.5 border border-slate-700/50">
              <span className="font-medium text-white text-sm">{displayName}</span>
              {groqLoading && (
                <span className="inline-block w-4 h-4 border-2 border-blue-400 border-t-transparent rounded-full animate-spin" aria-label="Loading" />
              )}
            </div>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a2 2 0 01-2.828 0l-4.243-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
            <span className="text-slate-300">
              {location?.name ? (
                <span className="text-emerald-400 font-medium">{location.name}</span>
              ) : (
                <span className="italic text-slate-500">No location set</span>
              )}
            </span>
          </div>
          {(typeof location?.lat === "number" && typeof location?.lon === "number") && (
            <div className="text-xs text-slate-400 font-mono">
              {location.lat.toFixed(4)}°, {location.lon.toFixed(4)}°
            </div>
          )}
          {groqContext && (
            <div className="text-xs italic text-blue-200 mt-1">{groqContext}</div>
          )}
        </div>
      </div>


      {/* Error message */}
      {error && (
        <div className="absolute left-1/2 top-full mt-2 -translate-x-1/2 bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded shadow text-xs flex items-center gap-2 z-50">
          <span>{error}</span>
          <button
            className="ml-2 text-red-500 hover:text-red-700 font-bold"
            onClick={() => setError(null)}
            aria-label="Dismiss error"
          >
            ×
          </button>
        </div>
      )}
    </header>
  );
};

export default PersistentHeader;
